/** Valid tax rate options */
export const TAX_RATES = {
  STANDARD: 'standard',
  BORDER: 'border',
} as const;

export type TaxRateValue = typeof TAX_RATES[keyof typeof TAX_RATES];

/** Maps a semantic tax rate to its IVA percent value. */
export const getTaxPercentValue = (rate: TaxRateValue): number => {
  const map: Record<TaxRateValue, number> = {
    [TAX_RATES.STANDARD]: 16,
    [TAX_RATES.BORDER]: 8,
  };
  return map[rate];
};

/** Tax configuration value object — selected tax rate */
export type TaxConfig = Readonly<{
  rate: TaxRateValue;
}>;

const VALID_RATES = new Set<string>(Object.values(TAX_RATES));

/**
 * Creates a validated TaxConfig value object.
 *
 * @param rate - Tax rate identifier ('standard' = 16%, 'border' = 8%)
 * @returns Frozen TaxConfig
 * @throws Error if rate is not a valid option
 */
export const createTaxConfig = (rate: string): TaxConfig => {
  if (!VALID_RATES.has(rate)) {
    throw new Error(`Invalid tax rate: ${rate}. Must be one of: ${[...VALID_RATES].join(', ')}`);
  }
  return Object.freeze({ rate: rate as TaxRateValue });
};
